import { useEffect, useState } from 'react'
import { CookieChoice, useCookieChoice } from './useCookieConsent'
import { enableAnalytics } from '../helpers/gtm'

import { useVisitorData } from '@fingerprintjs/fingerprintjs-pro-react'
import { getConfig } from '../helpers/fpjs'

export const useRouteChangeAnalytics = () => {
  const { cookieChoice } = useCookieChoice()
  const { data } = useVisitorData(getConfig)

  const [analyticsEnabled, setAnalyticsEnabled] = useState(false)

  useEffect(() => {
    if (
      !analyticsEnabled &&
      data &&
      cookieChoice.includes(CookieChoice.Analytics) &&
      cookieChoice.includes(CookieChoice.Advertising)
    ) {
      enableAnalytics(data.visitorId)
      setAnalyticsEnabled(true)
    }
  }, [cookieChoice, analyticsEnabled, data])
}
